import React from 'react';

export default function RoomCodeSign(props) {
  const code = props.roomCode;

  const svgStyle = {
    transform: "rotate(-8deg)",
    width: "94%",
    marginLeft: "1.5%",
    marginBottom: "6%",
  }

  return <div>
      <svg viewBox="0 0 200 140" style={svgStyle}>

        <polyline points="0,50 100,10 200,50" fill="none" stroke="#a47a00" strokeWidth="5"></polyline>
        <circle cx="100" cy="10" r="10" fill="#000" />

        <rect width="200" height="100" x="0" y="40" fill="#d7c68c" transform=""/>
        <rect width="200" height="5" x="0" y="40" fill="#cead4d" transform=""/>
        <rect width="200" height="5" x="0" y="135" fill="#cead4d" transform=""/>

        <text x="50%" textAnchor="middle" y="70" fontSize="20px">Room Code</text>
        <text x="50%" textAnchor="middle" y="120" fontSize="50px">{code}</text>

      </svg>
    </div>

}
